import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import SlideShowManagement from "./SlideShowManagement";
import RequestsManagement from "./RequestsManagement";
import { AuthContext } from "../../context/AuthContext";
import "../../styles/ControlPanel.css";

const ControlPanel = () => {
  const [activeSection, setActiveSection] = useState("requests"); // Default to requests as it's more frequently used
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { setIsAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    setIsAuthenticated(false);
    navigate("/login");
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const renderActiveSection = () => {
    switch (activeSection) {
      case "slideShow":
        return <SlideShowManagement />;
      case "requests":
        return <RequestsManagement />;
      default:
        return <RequestsManagement />;
    }
  };

  return (
    <div className="control-panel-dashboard">
      {/* Mobile Header */}
      <div className="mobile-header">
        <h2>Admin Panel</h2>
        <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
          ☰
        </button>
      </div>

      {/* Sidebar */}
      <aside className={`dashboard-sidebar ${isMobileMenuOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <h3>Control Panel</h3>
        </div>
        <nav className="sidebar-nav">
          <ul>
            <li
              className={activeSection === "requests" ? "active" : ""}
              onClick={() => {
                setActiveSection("requests");
                setIsMobileMenuOpen(false);
              }}
            >
              <span className="icon">📋</span> Requests
            </li>
            <li
              className={activeSection === "slideShow" ? "active" : ""}
              onClick={() => {
                setActiveSection("slideShow");
                setIsMobileMenuOpen(false);
              }}
            >
              <span className="icon">🖼️</span> Slideshow
            </li>
          </ul>
        </nav>
        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            <span className="icon">🚪</span> Logout
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="dashboard-main">
        {renderActiveSection()}
      </main>

      {/* Overlay for mobile menu */}
      {isMobileMenuOpen && (
        <div className="sidebar-overlay" onClick={() => setIsMobileMenuOpen(false)}></div>
      )}
    </div>
  );
};

export default ControlPanel;
